<ms-scroll-adapter [msScrollSelectedInView]="activeEventId()" [stretch]="false">
    <ul class="event-list-container">
        <li
            class="event-list-item"
            *rxFor="let eventCarouselItem of eventCarouselItems(); index as i; trackBy: trackByEventId; renderCallback: itemsRendered"
            [attr.data-menu-item-id]="eventCarouselItem.event.id"
            [class.selected]="eventCarouselItem.event.id === activeEventId()"
            (click)="tileClick(eventCarouselItem, i)">
            @if (eventCarouselItem.eventLink) {
                <ng-container *ngTemplateOutlet="linkTemplate; context: { $implicit: eventCarouselItem }" />
            } @else {
                <ng-container *ngTemplateOutlet="eventDetailCardTemplate; context: { $implicit: eventCarouselItem }" />
            }
        </li>
        @if (isLoading()) {
            <li class="event-list-item skeleton-item">
                <ms-event-carousel-skeleton />
            </li>
        }
    </ul>
</ms-scroll-adapter>

<ng-template #linkTemplate let-carouselItem>
    <a [vnSpeculativeLink]="carouselItem.eventLink">
        <ng-container *ngTemplateOutlet="eventDetailCardTemplate; context: { $implicit: carouselItem }" />
    </a>
</ng-template>

<ng-template #eventDetailCardTemplate let-carouselItem>
    <ds-card withHover msThemedCard class="event-detail-ds-card" [elevated]="false" [noBorderRadius]="false" [themeCardElevated]="themeElevated">
        <ms-event-detail-card [eventCarouselItem]="carouselItem"
    /></ds-card>
</ng-template>
